export const DEFAULT_SIMPLE_REG_COUNTRIES = ['KG'] as const

export const SIMPLE_REG_SCENARIO = 'refCodeSimple'

/** FR-30.3: версия формы для сегментации аналитики и A/B-тестов. */
export const SIMPLE_REG_VERSION = 'simplified_v1'

/** Те же правила, что в usePasswordRules: 6+ символов и хотя бы одна цифра/символ. */
export function hasPasswordMinLength(pass: string) {
  return (pass || '').length > 5
}

export function hasPasswordSpecialOrDigit(pass: string) {
  return /[^A-Za-zа-яА-Я]/.test(pass || '')
}

export function isPasswordValid(pass: string) {
  return hasPasswordMinLength(pass) && hasPasswordSpecialOrDigit(pass)
}

export function isSimpleRegCountry(
  countryCode: string | undefined | null,
  enabledCountries?: readonly string[] | null,
) {
  if (!countryCode) return false
  const list = enabledCountries?.length
    ? enabledCountries
    : DEFAULT_SIMPLE_REG_COUNTRIES
  return (list as readonly string[]).includes(countryCode)
}

export function isSimpleRegScenario(
  scenario: string | undefined | null,
) {
  return scenario === SIMPLE_REG_SCENARIO
}
